import React, {useEffect, useState, useRef} from "react";
import './index.css';

type InfoBoxProps = {
    className?: string;
    middle?;
    big?;
    title: string;
    content: any;
    smallContent?
    range?: number[];
}

function InfoBox({className, middle, big, title, content, smallContent, range}: InfoBoxProps){
    const [percentile, setPercentile] = useState(0);
    const graphLocationRef = useRef(null); // InfoBox__graphLocation에 대한 참조
 
    useEffect(()=>{
        if (range && range.length === 2) {
            const min = range[0]? range[0]:0;
            const max = range[1]? range[1]:0;
            const percentile = ((content - min) / (max - min)) * 100;
            setPercentile(percentile);
        }
    }, [range, content]);

    return(
        <>
            <div className={`
                    InfoBox__sectionBox 
                    ${(big || middle) && 'InfoBox__Big'} 
                    ${className || ''}
                `}
            >
                <div className='InfoBox__boxTitle'>{title}</div>
                <div className='InfoBox__boxContentWrap'>
                    <div className={`
                            ${big? 'InfoBox__boxContentBig':middle? 'InfoBox_boxContentMiddle':'InfoBox__boxContent'}
                        `}>
                            {content} <span className='InfoBox__smallContent'>{smallContent}</span>
                    </div>
                    {range&&
                        <div className="InfoBox__graphWrap">
                            <div className="InfoBox__graphLocation" style={{ left: `${percentile}%` }}>
                                <div className="InfoBox__graph">you</div>
                                <div className="triangle"></div>
                            </div>
                            <div className="InfoBox__graphBar" />
                        </div>
                    }

                </div>
            </div>
        </>
    )
}

export default InfoBox;